import './language.header.css';

function LanguageHeader() {
  return (
    <header className="App">
      <div className='logo-box'>
        <div>SHOESHOP</div>
        <img className='language-logo' alt='logo' src='https://www.logo.wine/a/logo/Converse_(shoe_company)/Converse_(shoe_company)-Icon-Logo.wine.svg' />
      </div>
    </header>
  );
}

export default LanguageHeader;
